

import React, { useEffect, useState } from "react";
import {
  Users,
  IndianRupee,
  Repeat,
  Pencil,
  Trash,
} from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import "./overview.css";

const API = "https://bodhimaram.onrender.com/api/students";

export default function Overview() {
  const { groupid } = useParams();
  const navigate = useNavigate();

  const [group, setGroup] = useState();
  const [members, setMembers] = useState([]);   // ✅ NEW
  const [loading, setLoading] = useState(true);
  const [showEdit, setShowEdit] = useState(false);

  const [groupName, setGroupName] = useState("");
  const [assignedFees, setAssignedFees] = useState("");
  const [recurrence, setRecurrence] = useState("monthly");
  const [groupIcon, setGroupIcon] = useState(null);
  const [groupIconPreview, setGroupIconPreview] = useState(null);

  // 🔥 LOAD GROUP + STUDENTS
  useEffect(() => {
    async function load() {
      try {
        // group
        const res = await fetch(`https://bodhimaram.onrender.com/group/groups/${groupid}`);
        const data = await res.json();
        setGroup(data);

        setGroupName(data.name || "");
        setAssignedFees(data.assigned_fees || "");
        setRecurrence(data.time_option || "monthly");
        setGroupIconPreview(data.icon ? `https://bodhimaram.onrender.com${data.icon}` : null);

        // students
        const membersRes = await fetch(`${API}/${data.group_code || data.id}`);
        const membersData = await membersRes.json();
        setMembers(Array.isArray(membersData) ? membersData : []);

      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [groupid]);

  if (loading) return <p>Loading...</p>;
  if (!group) return <p>Group not found</p>;

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
       const formData = new FormData();
      formData.append("name", groupName);
      formData.append("assigned_fees", assignedFees);
      formData.append("time_option", recurrence);

      if (groupIcon) {
        formData.append("icon", groupIcon);
      }

      const res = await fetch(`https://bodhimaram.onrender.com/group/groups/${group.id}`, {
        method: "PUT",
        body: formData,
      });

      if (!res.ok) throw new Error("Update failed");
      const data = await res.json();
      setGroup(data);
       setShowEdit(false);
     } catch (err) {
       console.error("Error updating group:", err);
     }
   };

  // delete
  const handleDeleteGroup = async () => {
    if (!window.confirm("Delete this group?")) return;

    await fetch(`https://bodhimaram.onrender.com/group/groups/${groupid}`, {
      method: "DELETE",
    });

    navigate("/dashboard/groups");
  };

  return (
    <div className="overview_container">

      {/* LEFT SIDE */}
      <div className="overview_left">
        <div className="overview_card">
          <div className="overview_header">
            {group.icon && (
              <img
                src={`https://bodhimaram.onrender.com${group.icon}`}
                alt=""
                className="overview_icon"
              />
            )}
            <h3>{group.name}</h3>

            <button onClick={() => setShowEdit(true)}>
              <Pencil size={18} />
            </button>
          </div>

          <p className="overview_muted">
            Created on {new Date(group.created_at).toLocaleDateString()}
          </p>

          <div className="overview_kv">
            <div className="overview_kvItem">
              <Users size={16} /> Members
            </div>
            <div>{members.length}</div>

            <div className="overview_kvItem">
              <IndianRupee size={16} /> Fee Amount
            </div>
            <div>₹{group.assigned_fees}</div>

            <div className="overview_kvItem">
              <Repeat size={16} /> Timings
            </div>
            <div>{group.time_option}</div>
          </div>

          <button className="overview_deleteBtn" onClick={handleDeleteGroup}>
            <Trash size={16} /> Delete
          </button>
        </div>
      </div>

      {/* RIGHT SIDE → STUDENTS */}
      <div className="overview_right">
        <div className="overview_card">
     <h3>
  Students
  <span className="student_count">({members.length})</span>
</h3>

          <div className="student_grid">

            {members.map((m) => (
              <div
                key={m.id}
                className="student_card"
                onClick={() => navigate(`/dashboard/student/${m.id}`)}   // 🔥 NAVIGATION
              >
                {m.student_image ? (
                  <img
                    src={`https://bodhimaram.onrender.com/uploads/students/${m.student_image}`}
                    alt=""
                  />
                ) : (
                  <div className="student_placeholder">👤</div>
                )}

                <p>{m.childname}</p>
              </div>
            ))}

            {!members.length && <p>No students found</p>}
          </div>
        </div>
      </div>

      
      {showEdit && (
         <div
           className="group-modal-overlay"
           onClick={() => setShowEdit(false)}
         >
           <div className="modal-group" onClick={(e) => e.stopPropagation()}>
             <h3>Edit Group</h3>

             <form onSubmit={handleSubmit}>
               <input
                 type="text"
                 value={groupName}
                onChange={(e) => setGroupName(e.target.value)}
                 placeholder="Enter Group/Class name"
               />

               <input
                 type="number"
                 value={assignedFees}
                 onChange={(e) => setAssignedFees(e.target.value)}
                 placeholder="Enter Assigned Fees"
               />

               <label className="recurrence-label">Recurrence</label>
               <select
                 value={recurrence}
                 onChange={(e) => setRecurrence(e.target.value)}
               >
                 <option value="monthly">Monthly</option>
                 <option value="quarterly">Quarterly</option>
                 <option value="yearly">Yearly</option>
               </select>

               <div className="upload-field">
                 <label>Group Icon</label>
                 <input
                   type="file"
                   accept="image/*"
                   onChange={(e) => {
                     const file = e.target.files[0];
                     setGroupIcon(file);
                     setGroupIconPreview(file ? URL.createObjectURL(file) : null);
                   }}
                 />
                 {groupIconPreview && (
                   <div className="image-preview-wrapper">
                     <img
                       src={groupIconPreview}
                       alt="Preview"
                       className="preview-icon"
                     />
                     <button
                       type="button"
                       className="remove-preview-btn"
                       onClick={() => {
                         setGroupIcon(null);
                         setGroupIconPreview(null);
                       }}
                     >
                       ✕
                     </button>
                   </div>
                 )}
               </div>

               <div className="modal-actions">
                 <button type="submit" className="save-btn">
                   Save Changes
                 </button>
                 <button
                   type="button"
                   className="cancel-btn"
                   onClick={() => setShowEdit(false)}
                 >
                   Cancel
                 </button>
               </div>
             </form>
           </div>
         </div>
       )}
    </div>
  );
}